/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { EnrolmentProcessingState } from 'common-typescript/types';

@Pipe({
    name: 'enrolmentProcessingStateMessageKey',
    standalone: false,
})
export class EnrolmentProcessingStateMessageKeyPipe implements PipeTransform {
    transform(state: EnrolmentProcessingState): string {
        return `ENROLMENT.ENROLMENT_PROCESSING_STATE.${state}`;
    }
}
